import { Mui } from "@osu/react-ui";
import { conjugate } from "../../util/functions";

export const DialogSummaryBox = ({ totalCount }) => {
  return (
    <Mui.Box sx={{ mt: 2, p: 2, backgroundColor: '#f9f9f9', borderRadius: 1 }}>
      <Mui.Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
        <strong>Summary:</strong>
      </Mui.Typography>
      <Mui.Typography variant="body2" color="text.secondary" sx={{ ml: 2 }}>
        {totalCount} item{conjugate('trailingS', totalCount)} will be submitted
      </Mui.Typography>
    </Mui.Box>
  )
}

export default DialogSummaryBox